//./context/AuthContext
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';



// 創建 AuthContext
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const navigate = useNavigate();

  // 初始化時檢查 token 並設置使用者狀態
  useEffect(() => {
    const initializeAuth = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get('token');

      if (tokenFromUrl) {
        localStorage.setItem('token', tokenFromUrl);
        setToken(tokenFromUrl);
      }

      const storedToken = localStorage.getItem('token');
      if (storedToken) {
        try {
          const decoded = jwtDecode(storedToken);
          
          // 檢查 token 是否過期
          const currentTime = Date.now() / 1000;
          if (decoded.exp && decoded.exp < currentTime) {
            console.warn('Token expired, logging out');
            handleLogout();
            return;
          }
          
          setToken(storedToken);
          setIsAuthenticated(true);
          setUser({
            e_id: decoded.e_id,
            e_name: decoded.e_name,
            e_email: decoded.e_email,
            e_mobile: decoded.e_mobile,
            e_position: decoded.e_position,
            e_ssid: decoded.e_ssid,
            e_group: decoded.e_group,
            loginType: decoded.loginType,
          });
        } catch (error) {
          // Token 無效，靜默清除
          console.warn('Invalid token detected, clearing authentication');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setToken(null);
          setIsAuthenticated(false);
          setUser(null);
        }
      } else {
        // 沒有 token，設置為未認證狀態
        setIsAuthenticated(false);
        setUser(null);
      }
    };
    initializeAuth();
  }, []);

  const handleLogin = (tokenValue, userData) => {
    localStorage.setItem('token', tokenValue);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(tokenValue);
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setIsAuthenticated(false);
    setUser(null);
    navigate('/login'); // 使用 navigate 來進行路由導航
  };

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      user, 
      token, 
      handleLogin, 
      handleLogout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

// 自定義 Hook，用來方便地使用 AuthContext
export const useAuth = () => useContext(AuthContext);
